import { ValidPlatformArch } from '@kemu-io/hs-types';
import { useCallback, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import routes from '@common/routes';

export type BasicServiceInfo = {
	name: string;
	version: string;
	platform: ValidPlatformArch;
}

const encodeServiceInfo = (serviceInfo: BasicServiceInfo): string => {
	return encodeURIComponent(`${serviceInfo.name}:${serviceInfo.version}:${serviceInfo.platform}`);
};

export const decodeServiceInfo = (encodedServiceInfo: string | null): BasicServiceInfo | null => {
	if (!encodedServiceInfo) {
		return null;
	}

	const decoded = decodeURIComponent(encodedServiceInfo);
	const [name, version, platform] = decoded.split(':');
	return {
		name,
		version,
		platform: platform as ValidPlatformArch
	};
};

const useMarketplaceNavigator = () => {
  const navigate = useNavigate();
	const location = useLocation();

	const navigateToService = useCallback((serviceInfo: BasicServiceInfo | null) => {
		// const searchParams = new URLSearchParams(location.search);
		const searchParams = new URLSearchParams(routes.marketplace.getHubServicesRoute());

		if (serviceInfo) {
			searchParams.set('hs', encodeServiceInfo(serviceInfo));
		} else {
			searchParams.delete('hs');
		}

		// Preserve other query parameters while updating 'service'
		navigate({
			pathname: location.pathname,
			search: searchParams.toString()
		}, {
			replace: false // false to add to browser history
		});
	}, [location, navigate]);

  const result = useMemo(() => {
    return {
      navigateToService,
      currentService: decodeServiceInfo(location.search)
    };
  }, [location, navigateToService]);

  return result;
};

export default useMarketplaceNavigator;
